import { CompletePhaseDto, CreateVisitDto, UpdateVisitDto } from "../../api/models";
import { BookingStatus } from "../../enums/booking-status.enum";
import { environment } from "../../environments/environment";
import { BookingConsultationState } from "../../interfaces/booking-consultation-state.interface";

/**
 * Maps the booking consultation state to a DTO used to create a new visit.
 * @param state - The current booking state with all visit information.
 * @returns A CreateVisitDto object to be sent to the backend for creating the visit.
 */
export function mapBookingConsultationStateToCreateDto(
  state: BookingConsultationState,
): CreateVisitDto {
  const createdAt = new Date().toISOString();

  return {
    doctorId: state.doctorId!,
    doctorFirstName: state.doctorFirstName!,
    doctorLastName: state.doctorLastName!,
    doctorPersonalEmail: state.doctorPersonalEmail,
    patientId: state.patientId!,
    patientFirstName: state.patientFirstName!,
    patientLastName: state.patientLastName!,
    bookingDate: state.bookingDate!,
    status: BookingStatus.SCHEDULED,
    title: state.title!,
    tenant: environment.tenant,
    code: state.code || "000",
    price: state.price,
    createdAt,
    phaseId: state.phaseId ?? "",
    pathwayId: state.pathwayId ?? "",
    firstBookingConsultation: state.firstBookingConsultation || false,
    isProfessionalAPsycho: state.isProfessionalAPsycho || false
  };
}

/**
 * Maps the booking consultation state to a partial DTO used to update an existing visit.
 * @param state - The current booking state, possibly containing updated fields.
 * @returns A Partial<UpdateVisitDto> object to update only the necessary fields.
 */
export function mapBookingConsultationStateToUpdateDto(
  state: BookingConsultationState,
): UpdateVisitDto {
  return {
    doctorId: state.doctorId || "",
    doctorFirstName: state.doctorFirstName,
    doctorLastName: state.doctorLastName,
    doctorPersonalEmail: state.doctorPersonalEmail,
    patientId: state.patientId!,
    patientFirstName: state.patientFirstName,
    patientLastName: state.patientLastName,
    bookingDate: state.bookingDate,
    status: BookingStatus.SCHEDULED,
    code: state.code || "000",
    price: state.price,
    firstBookingConsultation: state.firstBookingConsultation || false,
    // payment: state.payment,
  };
}
